import * as types from '../mutation-types'
import { api } from './../../modules/api'
import { getEventLink } from '@/store/modules/general-settings'

const state = () => ({
  vipLetter: {
    data: null,
    showMessage: false
  }
})

const getters = { getVIPLetter: state => state.vipLetter }

const actions = {
  async sendVIPSingleLetter ({commit}, payload) {
    commit(types.SET_SPINNER_STATUS, true)
    try {
      await this.$axios.post(api.vipInvitation.reqSingle(), payload)
      const invitationLink = `${getEventLink()}registration`
      commit(types.SEND_VIP_SINGLE_LETTER, invitationLink)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Invitation was sent successfully!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE)
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async sendVIPMultipleLetters ({commit}, payload) {
    commit(types.SET_SPINNER_STATUS, true)
    try {
      const res = await this.$axios({
        method: 'post',
        url: api.vipInvitation.reqMultiple(),
        headers: {'Content-Type': 'multipart/form-data'},
        data: payload
      })
      if (res.status < 400) {
        commit(types.CREATE_SUCCESS_MESSAGE, 'Invitations were sent!')
      } else {
        throw Error
      }
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE)
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async sendBatchedItemsTable ({commit}, payload) {
    commit(types.SET_SPINNER_STATUS, true)
    try {
      const res = await this.$axios({
        method: 'post',
        url: api.vipInvitation.sendBatchedItemsTable(),
        headers: {'Content-Type': 'multipart/form-data'},
        data: payload
      })
      if (res.status < 400) {
        commit(types.CREATE_SUCCESS_MESSAGE, 'File uploaded!')
      } else {
        throw Error
      }
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE)
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  closeLetterModal ({commit}) {
    commit(types.SET_LETTER_MODAL_VISIBILITY, false)
  }
}

const mutations = {
  [types.SEND_VIP_SINGLE_LETTER] (state, data) {
    state.vipLetter.invitationLink = data
    state.vipLetter.showMessage = true
  },
  [types.SET_LETTER_MODAL_VISIBILITY] (state, status) {
    state.vipLetter.showMessage = status
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vipInvitation.js